import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { MotiveProiecteService } from '../motive-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { IMotivAddPayload, IMotivForm } from '../motive-proiecte.interface';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-add-motive-proiecte',
    templateUrl: './add-motive-proiecte.component.html',
    styleUrls: ['./add-motive-proiecte.component.scss']
})
export class AddMotiveProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddMotiveProiecteComponent>,
        private motiveProiecteService: MotiveProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as IMotivForm;
        const payload: IMotivAddPayload = {
            name
        };

        this.motiveProiecteService
            .addMotiv(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
